
import React, { useEffect, useState } from 'react';
import { Form, Select, ConfigProvider } from 'antd';
const { Option } = Select;
function onChange(value) {
    console.log(`selected ${value}`);
}
/*
function onBlur() {
    console.log('blur');
}

function onFocus() {
    console.log('focus');
}

function onSearch(val) {
    console.log('search:', val);
}
*/
const SelectField = (props) => {
    //{ label, name, placeholder, list } props;
    const label = props.label;
    const name = props.name;
    const isRequired = props.isRequired;
    const placeholder = props.placeholder;
    const list = props.list;
    // const [selected, setSelected] = useState(props.selected);
    // useEffect(() => {
    //     setSelected(props.selected);
    // }, [props.selected]);
    return (< ConfigProvider direction="rtl" >        
        <Form.Item name={name} label={label} labelCol={{ span: 24 }}
            rules={[
                {
                    required: isRequired,
                    message: `لطفا ${label} خود را وارد نمایید!`,
                },
            ]}
        >
            <Select
                placeholder={placeholder}
                showSearch
                onChange={props.handleParent}
                allowClear
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                //allowClear
                size={36}
            >
                {/* <Option value="male">male</Option>
                <Option value="female">female</Option>
                <Option value="other">other</Option> */
                }
                {
                    list.map((item, i) => {
                        return (<Option  key={i} value={item.id}>{item.title}</Option>)
                    })
                }
            </Select>

        </Form.Item>
    </ConfigProvider >
    )
}

    ;

export default SelectField;